<template>
  <form novalidate>
    <h4 class="h4 text--bold text--uppercase">
      Registro fotográfico adjunto
    </h4>
    <div class="mt-4 form__label form__label--opcional">
      <span class="mr-2">Adjuntar fotografías</span>
      <button type="button"
        class="boton boton--adjuntar boton--s"
        @click="$refs.registroFotografico.click()"
        :disabled="!editando || form.registroFotografico.length === 4"
      />
    </div>
    <div>
      <input
        class="no-display"
        ref="registroFotografico"
        type="file"
        accept="image/*"
        @change="leerArchivo"
      >
    </div>
    <div v-if="!mostrarNoConexion && !cargandoImgs">
      <div class="thumbnail" v-for="(foto, i) in form.registroFotografico" :key="i">
        <i
          v-if="editando"
          class="fas fa-trash text--extra-big text--rosado borrar-foto"
          @click="form.registroFotografico.splice(i, 1)"
        />
        <img :src="foto.img">
        <form-group
          class="my-0"
          :error="errors.has(`comentario${i}`) && submitted">
          <input
            v-model="foto.comentario"
            v-validate="'required'"
            :disabled="!editando"
            class="form__input"
            :name="`comentario${i}`"
            placeholder="Comentario..."
            required
          >
        </form-group>
      </div>
    </div>
    <div v-if="cargandoImgs" class="text--center mt-8">
      <i class="fa fa-spinner fa-spin fa-3x"/>
      <p class="text">Cargando fotos...</p>
    </div>
    <p v-if="mostrarNoConexion" class="text mt-8 d-flex">
      <i class="fas fa-fw fa-exclamation-triangle text--rojo mr-2"/>
      <span>No hay conexión a internet para cargar este contenido</span>
    </p>
  </form>
</template>

<script>
import isString from "lodash/isString";

export default {
  data,
  created,
  methods: {
    leerArchivo,
  },
  props: {
    editando: Boolean,
    submitted: Boolean,
    form: Object,
  },
};

function data() {
  return {
    mostrarNoConexion: false,
    enviando: false,
    cargandoImgs: false,
  };
}

function created() {
  if (this.form._id && isString(this.form.registroFotografico[0])) {
    if (navigator.onLine) {
      this.cargandoImgs = true;
      return this.$store
        .dispatch(this.$actions.getImgsForm, {
          registroFotografico: this.form.registroFotografico,
        })
        .then((resp) => {
          if (this.editando) {
            this.$emit("fotos-cargadas", resp.registroFotografico);
          }
          this.form.registroFotografico = resp.registroFotografico;
          return resp;
        })
        .finally(() => {
          this.cargandoImgs = false;
        });
    }
    this.mostrarNoConexion = true;
  }
  return null;
}

function leerArchivo() {
  const self = this;
  const reader = new FileReader();
  reader.onload = (e) => {
    self.form.registroFotografico.push({
      img: e.target.result,
      comentario: "",
    });
  };
  reader.readAsDataURL(self.$refs.registroFotografico.files[0]);
}
</script>
